module.exports = __webpack_public_path__ + "img/20180414165942.f3d935fe.jpg";